import { AudienceApi } from 'shared/api/requests/audience'
import { FilterFields, FilterFieldsPayload } from 'shared/api/requests/audience/schemas'
import { createAsyncAction } from 'shared/lib/redux'

interface FetchFilterFieldsPayload {
  allowUserId?: FilterFieldsPayload['allow_user_id']
  force?: boolean
  scenario?: FilterFieldsPayload['scenario']
}

export const fetchFilterFields = createAsyncAction<FilterFields, FetchFilterFieldsPayload>(
  'subscribers/availableFields',
  async ({ allowUserId, scenario } = {}) => {
    const response = await AudienceApi.filterFields({
      query: {
        allow_user_id: Boolean(allowUserId),
        scenario,
      },
    })

    return response.data
  },
  {
    condition: (payload = {}, { getState }) => {
      const { force = true } = payload
      const state = getState()
      const { fetched, fetching } = state.filter.fields

      if (!force && fetched) {
        return false
      }

      if (fetching) {
        return false
      }

      return true
    },
  },
)
